import _ from 'lodash';
import React from 'react';
import {useSelector} from 'react-redux';
import {makeStyles, TableCell, TableHead, TableRow} from '@material-ui/core';
import {OrganizationState} from '~/redux/reducers/OrganizationReducer';
import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import {selectOrganizationState} from '~/redux/selectors/organizationSelectors';

export const StoreMatrixTableHeader = () => {
    const organizationState = useSelector<GlobalApplicationState, OrganizationState>(
        selectOrganizationState
    );

    const {stores} = organizationState;

    const useStyles = makeStyles({
        matrixTableHeader: {
            maxWidth: '80px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            transform: 'translate(67px, -15px) rotate(315deg)',
        },
    });

    const {matrixTableHeader} = useStyles();

    return (
        <TableHead>
            <TableRow>
                <TableCell key="select-all-header" />
                {_.map(stores, (store) => {
                    const {name} = store;
                    return (
                        <TableCell className={matrixTableHeader} key={name}>
                            <div className="rotated-header-content">
                                <div className="rotated-store-name">{name}</div>
                            </div>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};

export default StoreMatrixTableHeader;
